/**
 * Topbar — Top navigation bar with user info, theme toggle, and mobile menu toggle.
 */

import { useAuth } from './AuthProvider';
import { ThemeToggle } from './ThemeToggle';
import config from '../config/app.config';

interface TopbarProps {
  onMenuToggle: () => void;
}

export function Topbar({ onMenuToggle }: TopbarProps) {
  const { user, logout } = useAuth();

  return (
    <header
      className="sticky top-0 z-30 flex items-center justify-between px-6 lg:px-8 border-b-2"
      style={{
        height: 'var(--topbar-height)',
        background: 'var(--color-topbar-bg)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderColor: 'var(--color-card-border)',
      }}
    >
      {/* Left: Mobile menu + Logo */}
      <div className="flex items-center gap-4">
        <button
          onClick={onMenuToggle}
          className="lg:hidden p-2 rounded-btn hover:bg-gray-200 min-w-[44px] min-h-[44px] flex items-center justify-center"
          aria-label="Toggle sidebar menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <span className="text-section-sm font-bold" style={{ color: 'var(--color-primary-teal)' }}>
          {config.logoText}
        </span>
      </div>

      {/* Right: Theme toggle + User info */}
      <div className="flex items-center gap-4">
        <ThemeToggle />
        {user && (
          <>
            <div className="text-right hidden sm:block">
              <p className="font-semibold text-[16px]" style={{ color: 'var(--color-text-primary)' }}>{user.name}</p>
              <p className="text-[14px]" style={{ color: 'var(--color-text-muted)' }}>{user.role}</p>
            </div>
            <button
              onClick={logout}
              className="btn-secondary !min-h-[40px] !px-4 !py-2 !text-[16px]"
              aria-label="Sign out"
            >
              Sign Out
            </button>
          </>
        )}
      </div>
    </header>
  );
}
